import { render, staticRenderFns } from "./EbModal.vue?vue&type=template&id=72c6aaea"
import script from "./EbModal.vue?vue&type=script&lang=js"
export * from "./EbModal.vue?vue&type=script&lang=js"
import style0 from "./EbModal.vue?vue&type=style&index=0&id=72c6aaea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports